import { InputRow } from '../InputRow';

export function PhosphorusPotassiumInstanceInputs({ type, rx }) {
  return (
    <>
      <InputRow name={`${type} Product`} value={rx?.product} />
      <InputRow name={`${type} Groupings (lbs/ac)`} value={rx?.grouping} />
      <InputRow
        name={`Other ${type} Apps (lbs/ac)`}
        value={rx?.otherApplications}
      />
    </>
  );
}
